

import { useDispatch, useSelector } from "react-redux";
import CheckoutFinishedView from "./view"
import { useEffect, useState } from "react";
import { clearUser, setUser } from "@/redux/ducks/user";
import { openApp } from "@/utils/functions";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function CheckoutFinished() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const [document] = useState(user?.document);

  const goToPlayStore = () => {
    openApp("android");
  }

  const goToAppleStore = () => {
    openApp("ios");
  }

  const goToTickets = () => navigate('/ticket/pin');

  const goBack = () => navigate('/');

  useEffect(() => {
    dispatch(clearUser());
    dispatch(setUser({
      document,
    }));
  }, []);

  return (
    <CheckoutFinishedView
      goToPlayStore={goToPlayStore}
      goToAppleStore={goToAppleStore}
      goBack={goBack}
      goToTickets={goToTickets}
    />
  );
}
